module.exports = require('../_components/@alicd/next-date-picker/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/date-picker/index.js
// module id = 105
// module chunks = 0